import { toast as originalToast } from "react-hot-toast";

const GLOBAL_TOAST_ID = "singleton-toast";

const toast = (message, options = {}) =>
  originalToast(message, { id: GLOBAL_TOAST_ID, ...options });

toast.success = (message, options = {}) =>
  originalToast.success(message, { id: GLOBAL_TOAST_ID, ...options });

toast.error = (message, options = {}) =>
  originalToast.error(message, { id: GLOBAL_TOAST_ID, ...options });

toast.loading = (message, options = {}) =>
  originalToast.loading(message, { id: GLOBAL_TOAST_ID, ...options });
// Forward all other original methods
toast.dismiss = originalToast.dismiss;
toast.remove = originalToast.remove;
toast.custom = originalToast.custom;

toast.warning = (message, options = {}) =>
  originalToast.warning(message, { id: GLOBAL_TOAST_ID, ...options});

toast.info = (message, options = {}) =>
  originalToast.info(message, {id: GLOBAL_TOAST_ID, ...options});

export default toast;
